"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("babel-helper-vue-jsx-merge-props"));

var _utils = require("../utils");

var _config = require("../config");

require("../asset/index.css");

var _excluded = ["attrs"],
    _excluded2 = ["component", "viewBox", "spin", "rotate", "tabIndex"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Icon = {
  name: 'H3Icon',
  functional: true,
  props: {
    component: [Object, Function],
    spin: Boolean,
    rotate: Number,
    tabIndex: [String, Number]
  },
  render: function render(h, ctx) {
    var _ctx$data = ctx.data;
    _ctx$data = _ctx$data === void 0 ? {} : _ctx$data;
    var attrs = _ctx$data.attrs,
        restData = (0, _objectWithoutProperties2["default"])(_ctx$data, _excluded),
        _ctx$props = ctx.props,
        props = _ctx$props === void 0 ? {} : _ctx$props,
        listeners = ctx.listeners,
        children = ctx.children;

    var _attrs$props = _objectSpread(_objectSpread({}, attrs), props),
        Component = _attrs$props.component,
        viewBox = _attrs$props.viewBox,
        spin = _attrs$props.spin,
        rotate = _attrs$props.rotate,
        tabIndex = _attrs$props.tabIndex,
        restProps = (0, _objectWithoutProperties2["default"])(_attrs$props, _excluded2);

    var onClick = listeners.click;
    var hasChildren = children && children.length;
    (0, _utils.warning)(Boolean(Component || hasChildren), 'Should have `component` prop or `children`.'); // useInsertStyles();

    var classString = _config.componentOptions.cssNamespace;
    var svgClassString = (0, _defineProperty2["default"])({}, "".concat(_config.componentOptions.cssNamespace, "-spin"), !!spin);
    var svgStyle = rotate ? {
      msTransform: "rotate(".concat(rotate, "deg)"),
      transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var innerSvgProps = {
      attrs: _objectSpread(_objectSpread({}, _utils.svgBaseProps), {}, {
        viewBox: viewBox
      }),
      "class": svgClassString,
      style: svgStyle
    };

    if (!viewBox) {
      delete innerSvgProps.attrs.viewBox;
    }

    var renderInnerNode = function renderInnerNode() {
      // component > children
      if (Component) {
        return typeof Component === 'function' ? Component(h, _objectSpread(_objectSpread({}, innerSvgProps), {}, {
          children: children
        })) : h(Component, innerSvgProps, [children]);
      }

      if (hasChildren) {
        (0, _utils.warning)(Boolean(viewBox) || children.length === 1 && children[0] && children[0].tag === 'use', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
        return h("svg", (0, _babelHelperVueJsxMergeProps["default"])([innerSvgProps, {
          attrs: {
            viewBox: viewBox
          }
        }]), [children]);
      }

      return null;
    };

    var iconTabIndex = tabIndex;

    if (iconTabIndex === undefined && onClick) {
      iconTabIndex = -1;
    }

    return h("span", (0, _babelHelperVueJsxMergeProps["default"])([{
      attrs: {
        role: "img",
        tabIndex: iconTabIndex
      },
      "class": classString
    }, _objectSpread(_objectSpread({}, restData), {}, {
      attrs: restProps,
      on: listeners
    })]), [renderInnerNode()]);
  }
};
var _default = Icon;
exports["default"] = _default;